module.exports = __webpack_public_path__ + "img/ETH.e8a2418db.svg";